import Vue from 'vue';

/** What the confirmation dialog asks. */
export interface ConfirmOptions {
  title: string;
  text?: string;
  /** Label of the button that goes ahead, e.g. "Verwijderen". */
  confirmLabel: string;
  /** Red button, for something that cannot be undone after saving. */
  danger?: boolean;
}

interface ConfirmState {
  open: boolean;
  options: ConfirmOptions;
  resolve: ((answer: boolean) => void) | null;
}

/** One dialog for the whole CMS, shown by ConfirmDialog.vue in App.vue. */
export const confirmState: ConfirmState = Vue.observable({ open: false, options: { title: '', confirmLabel: '' }, resolve: null });

/** Shows the dialog; resolves true when the editor goes ahead, false when they cancel or close it. */
export function askConfirm(options: ConfirmOptions): Promise<boolean> {
  if (confirmState.resolve) confirmState.resolve(false);
  return new Promise((resolve) => {
    confirmState.options = options;
    confirmState.resolve = resolve;
    confirmState.open = true;
  });
}

export function answerConfirm(answer: boolean): void {
  const resolve = confirmState.resolve;
  confirmState.open = false;
  confirmState.resolve = null;
  if (resolve) resolve(answer);
}
